<div class="calendar-root gpd-full-page">
<div class="calendar-page">
  <aside class="entry-list-panel">
    <div class="entry-list-header">
      <div class="entry-list-heading">
        <h2 class="entry-list-month">{{ monthLabel }}</h2>
        <p class="entry-list-count">{{ sortedEntries.length }} {{ labelEntriesCount }}</p>
      </div>
      <gpd-filter
        class="entry-list-tag-filter"
        i18n-text="@@tags"
        text="Tags"
        [iconOnly]="true"
        [disableAll]="true"
        [activeWhenNotEmpty]="true"
        [options]="tagOptions"
        valueExpr="id"
        labelExpr="name"
        [value]="selectedTagIds"
        (valueChange)="setTagFilter($event)"
        i18n-title="@@filterByTag"
        title="Filter by tag"
      ></gpd-filter>
    </div>

    <div class="filter-pills">
      <gpd-pill
        [text]="labelAll"
        [clickable]="true"
        class="gpd-toggle-pill"
        [class.is-selected]="filterType === 'all'"
        [attr.aria-pressed]="filterType === 'all'"
        [backgroundColor]="filterType === 'all' ? 'var(--color-primary)' : 'transparent'"
        [color]="filterType === 'all' ? 'var(--color-white)' : 'var(--color-primary)'"
        (onClick)="setFilter('all')">
      </gpd-pill>
      <gpd-pill
        *ngIf="contractsEnabled"
        [text]="labelDeadline"
        [clickable]="true"
        class="gpd-toggle-pill"
        [class.is-selected]="filterType === 'deadline'"
        [attr.aria-pressed]="filterType === 'deadline'"
        [backgroundColor]="filterType === 'deadline' ? 'var(--color-primary)' : 'transparent'"
        [color]="filterType === 'deadline' ? 'var(--color-white)' : 'var(--color-primary)'"
        (onClick)="setFilter('deadline')">
      </gpd-pill>
      <gpd-pill
        [text]="labelTask"
        [clickable]="true"
        class="gpd-toggle-pill"
        [class.is-selected]="filterType === 'task'"
        [attr.aria-pressed]="filterType === 'task'"
        [backgroundColor]="filterType === 'task' ? 'var(--color-primary)' : 'transparent'"
        [color]="filterType === 'task' ? 'var(--color-white)' : 'var(--color-primary)'"
        (onClick)="setFilter('task')">
      </gpd-pill>
    </div>

    <ul class="entry-list">
      <li
        class="entry-row"
        *ngFor="let entry of sortedEntries; trackBy: trackByEntryId; let last = last"
        (click)="openEntry(entry)"
        [class.entry-row-active]="entry.id === selectedEntry?.id"
        [class.entry-row-no-border]="last">
        <ng-container *ngTemplateOutlet="entryRowContent; context: { $implicit: entry }"></ng-container>
      </li>

      <li class="entry-list-empty" *ngIf="sortedEntries.length === 0">
        <div class="entry-list-empty-text" i18n="@@calendarNoEntries">No entries.</div>
      </li>
    </ul>

    <ng-template #entryRowContent let-entry>
      <div class="entry-date">
        <span class="entry-day">{{ dayNumber(entry.date) }}</span>
        <span class="entry-month">{{ monthAbbreviation(entry.date) }}</span>
        <span class="entry-year">{{ entry.date.getFullYear() }}</span>
      </div>
      <div class="entry-info">
        <div class="entry-title">{{ entry.title }}</div>
        <div class="entry-type" [ngClass]="entry.chipClass">
          <span class="entry-dot"></span>{{ entry.chipLabel }}
        </div>
        <app-task-tags
          *ngIf="entryTags(entry).length"
          class="entry-tags"
          [tags]="entryTags(entry)"
          [max]="2"
          pillMaxWidth="110px"
        ></app-task-tags>
      </div>
    </ng-template>
  </aside>

  <app-calendar-month-panel
    [viewDate]="viewDate"
    [calendarDays]="calendarDays"
    [locale]="locale"
    [selectedEntryId]="$safeNavigationMigration(selectedEntry?.id)"
    (prevMonth)="goToPrevMonth()"
    (nextMonth)="goToNextMonth()"
    (today)="goToToday()"
    (monthPicked)="setViewDate($event)"
    (entryClick)="openEntry($event)"
    (dayAgendaOpen)="openDayAgenda($event)">
  </app-calendar-month-panel>
</div>

  <app-task-detail-panel
    *ngIf="selectedEntry?.type === 'task'"
    [visible]="selectedEntry?.type === 'task'"
    [entry]="selectedEntry"
    [projectId]="projectId"
    [siteId]="siteId"
    (onClose)="closeDetailPanel()"
    (onOpenTask)="openTaskRecord()">
  </app-task-detail-panel>

  <app-deadline-detail-panel
    *ngIf="selectedEntry?.type === 'deadline'"
    [visible]="selectedEntry?.type === 'deadline'"
    [entry]="selectedEntry"
    (onClose)="closeDetailPanel()"
    (onOpenContract)="openContractRecord()">
  </app-deadline-detail-panel>

  <!-- Day-agenda panel: opened from a day cell's "+N" indicator, lists every entry for that
       day. Mutually exclusive with the task/deadline panel above — openEntry()/openDayAgenda()
       each clear the other's state, since both dock to the same side. -->
  <app-calendar-day-agenda-panel
    [visible]="!!selectedOverflowDay"
    [day]="selectedOverflowDay"
    [locale]="locale"
    [selectedEntryId]="$safeNavigationMigration(selectedEntry?.id)"
    (close)="closeDayAgenda()"
    (entryClick)="openEntry($event)">
  </app-calendar-day-agenda-panel>
</div>
